export default "__VITE_ASSET__W5AZf8KE__"